import { SITE_OG_IMAGE, siteUrl } from './siteMeta';

function upsertMeta(attr: 'name' | 'property', key: string, content: string): void {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

export function applyMarketingDocumentMeta(opts: {
  title: string;
  description: string;
  pathname: string;
  lang: string;
}): void {
  const url = siteUrl(opts.pathname);
  document.title = opts.title;
  document.documentElement.lang = opts.lang;
  upsertMeta('name', 'description', opts.description);
  upsertMeta('name', 'robots', 'index, follow');
  upsertMeta('property', 'og:title', opts.title);
  upsertMeta('property', 'og:description', opts.description);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:image', SITE_OG_IMAGE);
  upsertMeta('name', 'twitter:title', opts.title);
  upsertMeta('name', 'twitter:description', opts.description);
  upsertLink('canonical', url);
}

export function applyAppDocumentMeta(title: string): void {
  document.title = title;
  upsertMeta('name', 'robots', 'noindex, nofollow');
}
